export default __webpack_public_path__ + "6cbab6adc0e92b2fd56e4c523e67a65e.jpg";